var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('left-menu'),_c('router-view',{key:_vm.$route.path}),(!_vm.ipad && !_vm.fullscreen)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }